/**
 * Component Registry for Weidner Apartment Homes Theme
 * 
 * Extends the base vantage theme registry with Weidner Apartment Homes specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-vantage/registry';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { HeroSolidBG } from './components/HeroSolidBG';
import { Footer } from './components/Footer';
import { FutureResidentsClub } from './components/FutureResidentsClub';
import { NeighborhoodSection } from './components/NeighborhoodSection';
import { ScheduleTourForm } from './components/ScheduleTourForm';
import { ContactForm } from './components/ContactForm';
import { PhotoGallery } from './components/PhotoGallery';
import { AmenitiesList } from './components/AmenitiesList';
import { PropertyOverview } from './components/PropertyOverview';
import { PricingVerbiage } from './components/PricingVerbiage';

/**
 * Weidner Apartment Homes specific component overrides.
 * These components have been customized for the Weidner Apartment Homes brand.
 */
const weidnerapartmenthomesOverrides: Partial<ComponentRegistry> = {
  Header,
  Hero,
  HeroSolidBG,
  Footer,
  FutureResidentsClub,
  NeighborhoodSection,
  ScheduleTourForm,
  ContactForm,
  PhotoGallery,
  AmenitiesList,
  PropertyOverview,
  PricingVerbiage,
};

/**
 * Final merged registry for Weidner Apartment Homes properties.
 * Inherits all components from the vantage theme, with Weidner Apartment Homes overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...weidnerapartmenthomesOverrides,
};

export default registry;
